import { Lightbulb, MessageSquareQuote, Sparkles } from 'lucide-react';

/** The icon of each reading of the Concierge on From notes (CT-5724); topics carry its spark, as in the prototype. */
export const NOTE_KIND_ICON = Object.freeze({
  summary: MessageSquareQuote,
  topic: Sparkles,
  interpretation: Lightbulb,
});
